/** @format */

import {toRegexp, toPath} from "@riotjs/route";

//menu以下
import menuIndex from "@tags/pages/menu/index.riot";
import information from "@tags/pages/menu/information.riot";
import informationDetail from "@tags/pages/menu/information-detail.riot";
import help from "@tags/pages/menu/help.riot";
import rules from "@tags/pages/menu/rules.riot";
import inquiry from "@tags/pages/menu/inquiry.riot";
import publicInfo from "@tags/pages/menu/public-info.riot";
import preview from "@tags/pages/menu/public-info/preview.riot";
import resign from "@tags/pages/menu/resign.riot";
import resignConfirm from "@tags/pages/menu/resign-confirm.riot";
import resignComplete from "@tags/pages/menu/resign-complete.riot";
import importComplete from "@tags/pages/menu/import-complete.riot";
import myNumberBrowsingApplication from "@tags/pages/menu/mynumber-browsing-application.riot";
import manual from "@tags/pages/menu/manual.riot";
import history from "@tags/pages/menu/history.riot";

const menus = [{
    path: "/menu",
    is: "index-tag",
    component: menuIndex,
},
    {
        path: "/menu/information",
        is: "information-tag",
        component: information,
    },
    {
        path: "/menu/information/:info_id",
        is: "information-detail-tag",
        component: informationDetail,
    },
    {
        path: "/menu/help",
        is: "help-tag",
        component: help,
    },
    {
        path: "/menu/help/:big_category",
        is: "help-tag",
        component: help,
    },
    {
        path: "/menu/help/:big_category/:small_category",
        is: "help-tag",
        component: help,
    },
    {
        path: "/menu/rules",
        is: "rules-tag",
        component: rules,
    },

    {
        path: "/menu/inquiry",
        is: "inquiry-tag",
        component: inquiry,
    },
    {
        path: "/menu/public-info",
        is: "public-info-tag",
        component: publicInfo,
    },
    {
        path: "/menu/public-info/preview",
        is: "preview-tag",
        component: preview,
    },

    {
        path: "/menu/resign",
        is: "resign-tag",
        component: resign,
    },
    {
        path: "/menu/resign/confirm",
        is: "resign-confirm-tag",
        component: resignConfirm,
    },
    {
        path: "/menu/resign/complete",
        is: "resign-complete-tag",
        component: resignComplete,
    },
    {
        path: "/menu/import/complete",
        is: "import-complete-tag",
        component: importComplete,
    },
    {
        path: "/menu/mynumber-browsing-application",
        is: "mynumber-browsing-application-tag",
        component: myNumberBrowsingApplication,
    },
    {
        path: "/menu/manual",
        is: "manual-tag",
        component: manual,
    },
    {
        path: "/menu/history",
        is: "history-tag",
        component: history,
    },
];

//ad以下
import adIndex from "@tags/pages/ad/index.riot";
import adEntried from "@tags/pages/ad/entried.riot";
import adInterest from "@tags/pages/ad/interest.riot";
import adSearch from "@tags/pages/ad/search.riot";
import adDetail from "@tags/pages/ad/detail.riot";
import adEntry from "@tags/pages/ad/entry.riot";

const ads = [{
    path: "/ad",
    is: "ad-index-tag",
    component: adIndex,
},
    {
        path: "/ad/entried",
        is: "ad-entried-tag",
        component: adEntried,
    },
    {
        path: "/ad/(interest|interested)",
        is: "ad-interest-tag",
        component: adInterest,
    },
    {
        path: "/ad/search",
        is: "ad-search-tag",
        component: adSearch,
    },
    {
        path: "/ad/detail/:ad_id",
        is: "ad-detail-tag",
        component: adDetail,
    },
    {
        path: "/ad/detail/:ad_id/entry",
        is: "ad-entry-tag",
        component: adEntry,
    }
];

//chat以下
import chatIndex from "@tags/pages/chat/index.riot";
import chatList from "@tags/pages/chat/list.riot";
import chatRoom from "@tags/pages/chat/room.riot";

const chats = [{
    path: "/chat",
    is: "chat-index-tag",
    component: chatIndex,
},
    {
        path: "/chat/index/:client_id",
        is: "chat-list-tag",
        component: chatList,
    },
    {
        path: "/chat/room/:room_id",
        is: "chat-room-tag",
        component: chatRoom,
    }
];


//project以下
import projectIndex from "@tags/pages/project/index.riot";
import projectDetail from "@tags/pages/project/detail.riot";
import projectDelivery from "@tags/pages/project/delivery.riot";
import projectHistory from "@tags/pages/project/history.riot";
import projectRewardsProject from "@tags/parts/project/history/rewards-project.riot";
import projectRewardsClient from "@tags/parts/project/history/rewards-client.riot";
import PaidSummary from "@tags/pages/project/paid-summary.riot";
import PaidSummaryDetail from "@tags/pages/project/paid-summary-detail.riot";
import projectInvoiceDetailForProject from "@tags/pages/project/invoice/detail-for-project.riot";

const projects = [{
    path: "/project",
    is: "project-index-tag",
    component: projectIndex,
},
    {
        path: "/project/detail/:project_id",
        is: "project-detail-tag",
        component: projectDetail,
    },
    {
        path: "/project/detail/:project_id/agreement",
        is: "project-detail-tag",
        component: projectDetail,
    },
    {
        path: "/project/delivery/:project_id",
        is: "project-delivery-tag",
        component: projectDelivery,
    },
    {
        path: "/project/history",
        is: "project-history-tag",
        component: projectHistory,
    },
    {
        path: "/project/history/rewards-project/:project_id",
        is: "project-rewards-project-tag",
        component: projectRewardsProject,
    },
    {
        path: "/project/history/rewards-client/:client_id",
        is: "project-rewards-worker-tag",
        component: projectRewardsClient,
    },
    {
        path: "/project/paid-summary",
        is: "paid-summary-tag",
        component: PaidSummary,
    },
    {
        path: "/project/paid-summary/detail/:target_year/:target_client_id",
        is: "paid-summary-derail-tag",
        component: PaidSummaryDetail,
    },
    {
        path: "/project/invoice/detail-for-project/:project_invoice_id",
        is: "project-invoice-detail-for-project-tag",
        component: projectInvoiceDetailForProject,
    },
];

//info以下
import infoIndex from "@tags/pages/info/index.riot";
import infoBankAccount from "@tags/pages/info/bank-account.riot";
import infoBankAccountConfirm from "@tags/pages/info/bank-account-confirm.riot";
import infoBasicInformation from "@tags/pages/info/basic-information.riot";
import infoBasicInformationApplication from "@tags/pages/info/basic-information-application.riot";
import infoBasicInformationApplicationConfirm from "@tags/pages/info/basic-information-application-confirm.riot";
import infoInvoiceProvider from "@tags/pages/info/invoice-provider.riot";

const infos = [{
    path: "/info",
    is: "info-index-tag",
    component: infoIndex,
},
    {
        path: "/info/bank-account",
        is: "info-bank-account-tag",
        component: infoBankAccount,
    },
    {
        path: "/info/bank-account-confirm",
        is: "info-bank-account-confirm-tag",
        component: infoBankAccountConfirm,
    },
    {
        path: "/info/basic-information",
        is: "info-basic-information-tag",
        component: infoBasicInformation,
    },
    {
        path: "/info/basic-information-application",
        is: "info-basic-information-application-tag",
        component: infoBasicInformationApplication,
    },
    {
        path: "/info/basic-information-application-confirm",
        is: "info-basic-information-application-confirm-tag",
        component: infoBasicInformationApplicationConfirm,
    },
    {
        path: "/info/invoice-provider",
        is: "info-invoice-provider-tag",
        component: infoInvoiceProvider
    }
];

const pages = menus
    .concat(infos)
    .concat(chats)
    .concat(projects)
    .concat(ads);

for (const page of pages) {
    page.route = toRegexp(page.path, [], {endsWith: "([#?].*)?"});
}

const routes = {
    pages,
    makePath: (name, param) =>
        toPath(pages.find((v) => v.is == name).path, param),
};

export default routes;